var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5795 14.2048C11.1402 13.7683 11.1402 13.0607 11.5795 12.6242C12.0188 12.1878 12.7312 12.1878 13.1705 12.6242L17.6705 17.0948C18.1099 17.5313 18.1099 18.2389 17.6705 18.6754C17.2312 19.1119 16.5189 19.1119 16.0795 18.6754L11.5795 14.2048Z",
    fill: "#BDBDBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.82352C0 12.1443 3.52577 15.647 7.87503 15.647C12.2243 15.647 15.7501 12.1443 15.7501 7.82352C15.7501 3.50271 12.2243 0 7.87503 0C3.52577 0 0 3.50271 0 7.82352ZM13.4995 7.82339C13.4995 10.9097 10.9811 13.4116 7.87448 13.4116C4.76787 13.4116 2.24946 10.9097 2.24946 7.82339C2.24946 4.73709 4.76787 2.23516 7.87448 2.23516C10.9811 2.23516 13.4995 4.73709 13.4995 7.82339Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.b1a19493a392f3b9cb49546b45ac04ce.svg";
export { ForwardRef as ReactComponent };